import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar-portable';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgClickOutsideDirective } from 'ng-click-outside2';

import { UIModule } from '../shared/ui/ui.module';
import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { RightsidebarComponent } from './rightsidebar/rightsidebar.component';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { VerticalComponent } from './vertical/vertical.component';
import { HorizontaltopbarComponent } from './horizontaltopbar/horizontaltopbar.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [LayoutComponent,
     SidebarComponent,
     TopbarComponent,
     FooterComponent,
     RightsidebarComponent, HorizontalComponent, VerticalComponent,
      HorizontaltopbarComponent],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    NgClickOutsideDirective,
    UIModule,ReactiveFormsModule,
    PerfectScrollbarModule
  ],
})
export class LayoutsModule { }
